function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Mobile_svg__clip0_8_104)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.136.142H61.452a4.322 4.322 0 0 0-4.306 4.335v92.01a4.32 4.32 0 0 0 4.306 4.334h45.978v15.883h-2.096a2.191 2.191 0 0 0-2.183 2.199v3.186h4.279v1.885h41.728v-1.885h4.28v-3.186a2.192 2.192 0 0 0-2.184-2.199h-1.972v-.138h-.135v-15.745h45.989a4.321 4.321 0 0 0 4.306-4.334V4.477a4.322 4.322 0 0 0-4.306-4.335z",
  fill: "#D0D7DD",
  opacity: 0.7
}), React.createElement("path", {
  d: "M149.018 98.086h-41.184v24.288h41.184V98.086z",
  fill: "#D0D7DD"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M108.645 100.462h39.645c.477-2.077.86-3.431.86-3.431h-41.448s.425 1.348.943 3.431z",
  fill: "#7E828B",
  opacity: 0.1
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.453.934H194.4a4.25 4.25 0 0 1 4.25 4.25v81.287H58.202V5.184a4.25 4.25 0 0 1 4.25-4.25z",
  fill: "#323C47"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.4 99.67H62.453a4.25 4.25 0 0 1-4.25-4.25v-8.95H198.65v8.95a4.25 4.25 0 0 1-4.25 4.25z",
  fill: "#D0D7DD"
}), React.createElement("path", {
  d: "M128.426 95.447a2.376 2.376 0 1 0 0-4.753 2.376 2.376 0 0 0 0 4.752z",
  fill: "#323C47"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.767 115.246h45.318c1.191 0 2.157.966 2.157 2.157v3.123H103.61v-3.123a2.156 2.156 0 0 1 2.157-2.157z",
  fill: "#D0D7DD"
}), React.createElement("path", {
  d: "M170.798 18.918H86.054c-.656 0-1.188.532-1.188 1.188V67.3c0 .656.532 1.188 1.188 1.188h84.744c.656 0 1.188-.532 1.188-1.188V20.106c0-.656-.532-1.188-1.188-1.188z",
  fill: "url(#Mobile_svg__paint0_linear_8_104)",
  opacity: 0.5
}), React.createElement("path", {
  d: "M169.681 19.282h-82.51c-.656 0-1.188.532-1.188 1.189V66.66c0 .656.532 1.188 1.188 1.188h82.51c.656 0 1.188-.532 1.188-1.188V20.47c0-.656-.532-1.188-1.188-1.188z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M146.587 26.255h-24.328a.467.467 0 0 0-.467.467v.065c0 .259.209.468.467.468h24.328c.258 0 .467-.21.467-.468v-.065a.467.467 0 0 0-.467-.467zM142.323 29.064h-20.064a.467.467 0 0 0-.467.467v.065c0 .259.209.468.467.468h20.064c.258 0 .467-.21.467-.468v-.065a.467.467 0 0 0-.467-.467zM146.587 39.354h-24.328a.467.467 0 0 0-.467.468v.065c0 .258.209.467.467.467h24.328c.258 0 .467-.209.467-.467v-.065a.467.467 0 0 0-.467-.468zM146.587 42.16h-24.328a.467.467 0 0 0-.467.468v.065c0 .259.209.468.467.468h24.328c.258 0 .467-.21.467-.468v-.065a.467.467 0 0 0-.467-.467zM146.587 52.454h-24.328a.467.467 0 0 0-.467.467v.066c0 .258.209.467.467.467h24.328c.258 0 .467-.21.467-.467v-.066a.467.467 0 0 0-.467-.467zM146.803 55.26h-24.591a.42.42 0 0 0-.42.42v.16c0 .232.188.42.42.42h24.591a.42.42 0 0 0 .42-.42v-.16a.42.42 0 0 0-.42-.42z",
  fill: "#E0E0E0"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 11.23V5.422z",
  fill: "#000"
}), React.createElement("path", {
  d: "M128.426 11.23V5.422",
  stroke: "#6C63FF",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 20.998v-7.621z",
  fill: "#000"
}), React.createElement("path", {
  d: "M128.426 20.998v-7.621",
  stroke: "#6C63FF",
  strokeWidth: 0.66
}), React.createElement("path", {
  d: "M128.426 22.054a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  fill: "#6C63FF"
}), React.createElement("path", {
  d: "M128.426 13.342a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  stroke: "#fff",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 11.23V5.422z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M128.426 11.23V5.422",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 20.998v-7.621z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M128.426 20.998v-7.621",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  d: "M128.426 22.054a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M128.426 13.342a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  stroke: "#fff",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 73.799v8.183z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M128.426 73.799v8.183",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.426 66.406v7.622z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M128.426 66.406v7.622",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  d: "M128.426 67.463a1.056 1.056 0 1 0 0-2.113 1.056 1.056 0 0 0 0 2.113z",
  fill: "#EB4235"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.906 44.627H72.59z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M80.906 44.627H72.59",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.166 44.627h-7.622z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M88.166 44.627h-7.622",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  d: "M88.166 45.682a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M149.15 115.114h-41.184v1h41.184v-1z",
  fill: "#7E828B",
  opacity: 0.1
}), React.createElement("path", {
  d: "M47.505 97.046H28.39l.264-2.149c5.402-4.85 8.894-17.77 8.894-17.77a1.8 1.8 0 0 0-.23.048c-3.167.639-5.422 1.94-6.998 3.506l.67-5.718c9.98-2.15 13.937-15.35 13.937-15.35-6.367 1.413-10.338 3.6-12.804 5.674l.982-8.4c6.748 2.315 13.728-9.985 13.728-9.985l-.264-.055.132-.085-.2.072c-7.458-1.608-11.445 2.655-12.738 4.427l.097-.824c-.197.528-.389 1.046-.575 1.552v.022a91.069 91.069 0 0 0-1.45 4.24c-.381 1.19-.739 2.37-1.071 3.537v-.016s-.31-7.513-8.232-9.49c0 0 .832 16.386 7.11 13.704a124.273 124.273 0 0 0-1.468 6.882 112.416 112.416 0 0 0-.687 4.224l-.037.042.037-.031-.015.108a100.287 100.287 0 0 0-.45 3.638c.122-2.276-.292-8.85-8.038-15.027 0 0-10.296 18.094 7.26 21.648l.116.1-.026-.082.158.035.071-.93a97.505 97.505 0 0 0 .061 11.643l.055.779H7.348c-7.376 15.256 4.097 23.617 4.097 23.617h31.68c12.303-15.507 4.38-23.586 4.38-23.586z",
  fill: "#D0D7DD",
  opacity: 0.7
}), React.createElement("path", {
  opacity: 0.6,
  d: "M27.314 102.838s-5.016-21.911 6.072-50.16",
  stroke: "#535461",
  strokeWidth: 0.792
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.778 96.239h38.808s7.656 9.767-4.224 24.287H11.738S.65 110.494 7.778 96.239z",
  fill: "#4DA1FF"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.83 54.13s3.856-6.864 13.096-4.752c0 0-7.637 13.005-14.52 8.747l1.423-3.995zM30.384 61.414s-.298-7.02-7.954-8.868c0 0 .792 15.312 6.864 12.804l1.09-3.936zM27.882 71.781s1.412-7.355 16.196-10.523c0 0-4.715 15.212-16.877 14.602l.68-4.079z",
  fill: "#00BB6E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.683 80.037s1.555-7.69-7.685-14.819c0 0-10.032 17.073 7.255 20.284l.43-5.465z",
  fill: "#00BB6E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.406 90.607S25.334 79.74 36.95 77.627c0 0-4.242 15.177-10.56 17.883l.016-4.903z",
  fill: "#00BB6E"
}), React.createElement("path", {
  opacity: 0.3,
  d: "M31.538 58.222s10.032-7.656 14.256-8.976M27.182 75.778s12.144-12.936 16.896-14.52M22.43 52.546s7.392 10.032 6.864 12.672M18.998 65.218s3.96 17.952 7.128 20.328M26.39 95.579s6.336-17.424 10.56-17.953",
  stroke: "#535461",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.586 96.239H7.778c-.087.176-.171.353-.264.527h37.752s7.469 9.534-3.801 23.76h.897c11.88-14.52 4.224-24.287 4.224-24.287z",
  fill: "#000",
  opacity: 0.1
}), React.createElement("path", {
  d: "M256.656 120.421H.196v8.693h256.46v-8.693zM245.787 129.114H11.062v3.556h234.725v-3.556z",
  fill: "#E9EFF4"
}), React.createElement("path", {
  opacity: 0.1,
  d: "M245.787 129.114H11.062v1.186h234.725v-1.186z",
  fill: "#7E828B"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.414 44.627h1.584z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M182.414 44.627h1.584",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.422 44.627h11.848z",
  fill: "#000"
}), React.createElement("path", {
  d: "M168.422 44.627h11.848",
  stroke: "#EB4235",
  strokeWidth: 0.66
}), React.createElement("path", {
  d: "M168.422 45.682a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M181.358 45.682a1.056 1.056 0 1 0 0-2.112 1.056 1.056 0 0 0 0 2.112z",
  stroke: "#fff",
  strokeWidth: 0.66
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M241.154 117.591l.027-.04a6.35 6.35 0 0 0 .161-.264l.029-.05c.051-.086.099-.174.145-.264l.024-.045a6.216 6.216 0 0 0 .396-.977l.026-.087c.024-.082.047-.163.069-.245l.026-.116c.018-.074.033-.149.048-.225 0-.042.015-.084.023-.127a6.93 6.93 0 0 0 .035-.224c.01-.077 0-.087.015-.129.016-.043.016-.161.022-.243v-.114-22.162h-3.657V81.591h-4.488v10.686h-3.094V76.93h-4.488v15.35h-1.687V74.736h-4.488v17.542h-3.96v21.807c0 3.559 2.96 6.441 6.6 6.441h12.672a6.647 6.647 0 0 0 5.343-2.655c.066-.094.132-.187.201-.28z",
  fill: "#D0D7DD",
  opacity: 0.7
}), React.createElement("path", {
  d: "M225.05 84.886h-4.224v26.4h4.224v-26.4z",
  fill: "#323C47"
}), React.createElement("path", {
  d: "M225.05 76.174h-4.224v8.712h4.224v-8.712z",
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M230.858 86.999h-4.224v26.399h4.224v-26.4z",
  fill: "#323C47"
}), React.createElement("path", {
  d: "M230.858 78.286h-4.224v8.712h4.224v-8.712z",
  fill: "#FFD012"
}), React.createElement("path", {
  d: "M237.986 91.487h-4.224v26.399h4.224v-26.4z",
  fill: "#323C47"
}), React.createElement("path", {
  d: "M237.986 82.775h-4.224v8.712h4.224v-8.712z",
  fill: "#4DA1FF"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.13 93.07h24.288v20.988a6.203 6.203 0 0 1-6.204 6.204h-11.88a6.204 6.204 0 0 1-6.204-6.204V93.07z",
  fill: "#4DA1FF"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M217.13 93.07v1.056h23.232v20.988a6.178 6.178 0 0 1-1.32 3.826 6.191 6.191 0 0 0 2.376-4.882V93.07H217.13z",
  fill: "#4DA1FF",
  opacity: 0.1
}), React.createElement("path", {
  d: "M117.797 26.255h-6.98c-.656 0-1.188.532-1.188 1.188v6.045c0 .656.532 1.188 1.188 1.188h6.98c.657 0 1.188-.532 1.188-1.188v-6.045c0-.656-.531-1.188-1.188-1.188zM117.797 52.454h-6.98c-.656 0-1.188.532-1.188 1.188v6.046c0 .656.532 1.188 1.188 1.188h6.98c.657 0 1.188-.532 1.188-1.188v-6.046c0-.656-.531-1.188-1.188-1.188zM117.797 39.354h-6.98c-.656 0-1.188.532-1.188 1.188v6.046c0 .656.532 1.188 1.188 1.188h6.98c.657 0 1.188-.532 1.188-1.188v-6.046c0-.656-.531-1.188-1.188-1.188z",
  fill: "#EB4235",
  opacity: 0.6
}), React.createElement("path", {
  fill: "#fff",
  d: "M89 22h78v43H89z"
}), React.createElement("g", {
  clipPath: "url(#Mobile_svg__clip1_8_104)"
}, React.createElement("path", {
  d: "M128.207 49.922c6.591 0 11.935-5.299 11.935-11.836s-5.344-11.836-11.935-11.836-11.934 5.3-11.934 11.836c0 6.537 5.343 11.836 11.934 11.836z",
  fill: "#E94235"
}), React.createElement("path", {
  d: "M128.207 46.314c-2.84 0-5.308-2.273-5.308-5.132 0-1.75.817-3.16 2.368-3.97-.882-.854-1.421-1.726-1.421-2.988a4.311 4.311 0 0 1 1.199-3.218 4.412 4.412 0 0 1 6.356.009 4.335 4.335 0 0 1 1.19 3.221c0 1.282-.559 2.135-1.441 2.988 1.551.81 2.368 2.218 2.368 3.97.005 2.847-2.47 5.12-5.311 5.12zm0-7.555a2.47 2.47 0 0 0-1.363.41 2.441 2.441 0 0 0-.903 1.092 2.417 2.417 0 0 0 .532 2.651 2.47 2.47 0 0 0 2.673.527 2.452 2.452 0 0 0 1.101-.895c.269-.4.413-.87.413-1.352.002-.32-.06-.638-.183-.934a2.435 2.435 0 0 0-1.328-1.323 2.473 2.473 0 0 0-.942-.186v.01zm0-6.19a1.72 1.72 0 0 0-1.59 1.038 1.69 1.69 0 0 0 .359 1.854 1.716 1.716 0 0 0 1.864.38 1.71 1.71 0 0 0 .773-.62c.19-.28.292-.607.294-.943a1.68 1.68 0 0 0-1.042-1.586 1.716 1.716 0 0 0-.658-.132v.01z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M114.034 55.31c.497-.835 1.528-1.264 2.612-1.264 2.055 0 3.76 1.479 3.76 3.84 0 2.362-1.732 3.858-3.775 3.858-1.037 0-2.105-.459-2.597-1.297v.493a.74.74 0 0 1-.734.727.723.723 0 0 1-.718-.727v-8.69a.722.722 0 0 1 .718-.74.75.75 0 0 1 .528.216c.14.139.218.327.218.523l-.012 3.062zm2.485 5.026a2.4 2.4 0 0 0 1.737-.72 2.362 2.362 0 0 0 .669-1.745 2.312 2.312 0 0 0-1.466-2.254 2.35 2.35 0 0 0-.94-.163c-1.195 0-2.47.838-2.47 2.417a2.337 2.337 0 0 0 .689 1.77 2.393 2.393 0 0 0 1.781.694zM127.673 60.447c-.497.838-1.578 1.297-2.612 1.297-2.04 0-3.778-1.519-3.778-3.858 0-2.339 1.74-3.84 3.778-3.84 1.034 0 2.117.429 2.612 1.264v-.458a.727.727 0 0 1 1.451 0v6.086c0 .19-.076.374-.212.509a.729.729 0 0 1-1.026 0 .713.713 0 0 1-.213-.51v-.49zm-2.485-4.994a2.362 2.362 0 0 0-1.742.687 2.317 2.317 0 0 0-.681 1.731 2.404 2.404 0 0 0 .688 1.767 2.461 2.461 0 0 0 3.517 0 2.404 2.404 0 0 0 .688-1.767c0-1.58-1.28-2.417-2.47-2.417zM133.044 60.48c.745 0 1.307-.395 1.307-.987 0-.537-.43-.806-.994-.934l-1.019-.246c-1.26-.333-2.008-.95-2.008-2.117 0-1.218 1.098-2.167 2.597-2.167.972 0 1.911.347 2.344 1.203.053.102.08.215.079.33a.676.676 0 0 1-.686.648.667.667 0 0 1-.527-.315 1.375 1.375 0 0 0-1.178-.617c-.701 0-1.163.412-1.163.964 0 .474.462.74.94.853l1.098.286c1.543.38 1.926 1.314 1.926 2.15 0 1.375-1.337 2.218-2.883 2.218-1.148 0-2.326-.631-2.676-1.77a1.042 1.042 0 0 1-.033-.222c0-.38.366-.57.701-.57a.647.647 0 0 1 .621.412c.214.533.806.88 1.554.88zM143.258 58.44h-5.482c.176 1.233 1.148 2.007 2.405 2.007.895 0 1.387-.222 1.897-.774a.746.746 0 0 1 .974-.19.642.642 0 0 1 .127.903c-.719.914-1.832 1.358-3.045 1.358-2.12 0-3.807-1.533-3.807-3.873 0-2.339 1.687-3.825 3.807-3.825s3.698 1.479 3.698 3.825a.577.577 0 0 1-.354.527.575.575 0 0 1-.22.043zm-.86-1.12a2.165 2.165 0 0 0-.735-1.434 2.204 2.204 0 0 0-1.529-.539c-1.228 0-2.182.74-2.358 1.972h4.622z",
  fill: "#343F50"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Mobile_svg__paint0_linear_8_104",
  x1: 4440.87,
  y1: 4975.78,
  x2: 4440.87,
  y2: 18.918,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("clipPath", {
  id: "Mobile_svg__clip0_8_104"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h257v133H0z"
})), React.createElement("clipPath", {
  id: "Mobile_svg__clip1_8_104"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(112.582 26.25)",
  d: "M0 0h31.25v35.494H0z"
})));

var SvgMobile = function SvgMobile(props) {
  return React.createElement("svg", _extends({
    width: 257,
    height: 133,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Mobile.d470c02a.svg";
export { SvgMobile as ReactComponent };